import { InputLabel, styled } from "@mui/material";

export const MapitInputLabel = styled(InputLabel)(({ theme }) => ({
    color: '#101828 !important',
    fontSize: '18px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
}));

export default MapitInputLabel;